/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EmailAddress } from "./EmailAddress";
import {
  EmailAddressFromJSON,
  EmailAddressFromJSONTyped,
  EmailAddressToJSON,
  EmailAddressToJSONTyped,
} from "./EmailAddress";

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   */
  readonly id?: number;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   */
  username: string;
  /**
   *
   */
  firstName?: string;
  /**
   *
   */
  lastName?: string;
  /**
   *
   */
  email?: EmailAddress;
  /**
   *
   */
  readonly externalUserId?: string | null;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
  if (!("username" in value) || value["username"] === undefined) return false;
  return true;
}

export function UserFromJSON(json: any): User {
  return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    username: json["username"],
    firstName: json["first_name"] == null ? undefined : json["first_name"],
    lastName: json["last_name"] == null ? undefined : json["last_name"],
    email: json["email"] == null ? undefined : EmailAddressFromJSON(json["email"]),
    externalUserId:
      json["external_user_id"] === undefined
        ? undefined
        : json["external_user_id"] === null
        ? null
        : json["external_user_id"],
  };
}

export function UserToJSON(json: any): User {
  return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(
  value?: Omit<User, "id" | "externalUserId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    username: value["username"],
    first_name: value["firstName"],
    last_name: value["lastName"],
    email: EmailAddressToJSON(value["email"]),
  };
}
